import { render, staticRenderFns } from "./negotiationRemark.vue?vue&type=template&id=63eb14a8&scoped=true"
import script from "./negotiationRemark.vue?vue&type=script&lang=js"
export * from "./negotiationRemark.vue?vue&type=script&lang=js"
import style0 from "./negotiationRemark.vue?vue&type=style&index=0&id=63eb14a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb14a8",
  null
  
)

export default component.exports